export default __webpack_public_path__ + "static/media/nft-grant-permission-icon.37cbdf61.svg";